<template>
  <div style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast" @blur="closeModal">
    <div class="uk-modal-dialog tm-func-modal" v-click-outside="closeModal">
      <div class="uk-modal-header">
        <div class="tm-background-green uk-padding-xsmall uk-position-top-right uk-text-bold tm-light 6" data-uk-tooltip="Закрыть" style="cursor: pointer;" @click="closeModal"><md-icon>close</md-icon></div>
        <div class="uk-modal-title">
          Рейтинговые показатели
        </div>
      </div>
      <div class="uk-modal-body">
        <div class="uk-margin uk-text-bold">
          Вид про-ретушера
        </div>
        <div class="uk-grid uk-grid-small uk-child-width-1-1" data-uk-grid>
          <div>
            1) в разделе рейтинговых показателей отображаются все заказы, которые были получены клиентом или возвращенные от клиента
          </div>
          <div>
            2) заказы в раздел собираются из таблиц: basic_orders, order_admin_comments, orders_likes, orders_log_rejected_retouchers_type
          </div>
          <div>
            3) напротив каждого заказа могут быть отметки:<br>
            - <i class="md-icon md-icon-font tm-senior-mark-icon md-theme-default tm-senior-mark-icon-gray"> circle </i> - заказ ожидает проработку от про ретушера<br>
            - <i class="md-icon md-icon-font tm-senior-mark-icon md-theme-default tm-icon-blue"> cached </i> - про-ретушер проработал заказ и ожидается комментарий от сеньора на замечания<br>
            - <i class="md-icon md-icon-font tm-senior-mark-icon md-theme-default tm-icon-close"> close </i> - сеньер при проработке заказа нажал кнопку "Плохо", про-ретушер должен проработать заказ заново (далее синие стрелки после проработки)<br>
            - <i class="md-icon md-icon-font tm-senior-mark-icon md-theme-default tm-icon-done"> done </i> - сеньер поставил ХОРОШО или принял комментарий от про-ретушера после синих стрелок<br>
            - <i class="md-icon md-icon-font tm-senior-mark-icon md-theme-default tm-senior-mark-icon-people"> people_outline </i> - заказ не требующих внимания данного про-ретушера, сеньер сделал отметку для другого про-ретушера, но в чате данного заказа участвовал текущий про-ретушер
          </div>

          <div>
            4) про-ретушер может описываться на каждый ответ сеньера
          </div>
          <div>
            5) бонус за неделю - получают 3 про-ретушера с наибольших показателем и с минимальным кол-во обработанных заказов в 300 шт, на бонус влияют число выполненных заказов, количество поставленных оценок заказчиками, количество брошенных заказов и отказов от заказов<br>
            расчет бонуса за неделю: 50% (дается в начале каждой недели) + (2% за каждый 5*) + (0% за каждые 4*) - (2% за каждые 3*) - (4% за каждые 2*) - (6% за каждые 1*)<br>
            максимально значение может быть 150%
          </div>
          <div>
            6) бонус за проработку ошибок (+10%) - начисляется при наличии у всех заказов зеленого чека (1-4*, дизлайки от сеньера, отметка халтура от сеньера), кроме заказов 5* и redo
          </div>
          <div>
            7) штраф за халтурную работу (-10%) - за каждую заказ с красным крестиком -10% (чекбокс ХАЛТУРА от сеньера), показатель суммируется, даже если сеньер принял ответ про-ретушера и поставил зеленый чекбокс штраф все равно -10%
          </div>
          <div>
            8) сеньеры начинают проработку заказов на следующую неделю после текущей (со вторника по субботу)
          </div>
          <div>
            9) зп ведомость за неделю формируется на след понедельник утром (в 7:10 расчет зп ведомости, в 8:10 расчет бонусов и штрафов), но без 10% за проработку и штрафов за халтуру за прошлую неделю, но с учетом 10% за проработку и штраф за халтуру за позапрошлую неделю<br>
            на примере 37 недели: зп формируется в понедельник утром (в 7:10 расчет зп ведомости, в 8:10 расчет бонусов и штрафов) 38 недели за 37 неделю + 10% бонус проработку за 36 неделю - штрафы за халтуру за 36 неделю
          </div>
          <div>
            10) если зарплата выплачена, фиксируется бонус и штраф за неделю в рейтинге, и в дальнейшем не меняется при оценке сеньером
          </div>
        </div>
     </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  components: {},
  computed: {},
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
  async created() {
  }
}
</script>